export default __webpack_public_path__ + "static/media/satish chitre.9ae0b055.jpg";